import { getEmojiMart } from "@circle-react-shared/uikit/TipTapBlockEditor/InlineEmojiExtension/getEmojiMart";
import { useEffect } from "react";
import { useQuery } from "react-query";

import { getEmojiMartV5Data } from "./data";

interface EmojiData {
  aliases: string[];
  categories: string[];
  emojis: string[];
  sheet: string[];
}

export const useEmojiMartData = () => {
  const query = useQuery<EmojiData, Error, EmojiData, string[]>({
    queryKey: ["emoji-mart-data"],
    queryFn: getEmojiMartV5Data,
    staleTime: 1000 * 60 * 60 * 24,
  });

  useEffect(() => {
    if (!query.data) return;

    const data = query.data;
    void getEmojiMart().then(({ init }) => init({ data }));
  }, [query.data]);

  return query;
};
